import React from 'react';

import './Copyright.scss';

const Copyright = ({ className }) => {
  return (
    <small
      className={`copyright ${className}`}
    >{`© ${new Date().getFullYear()} kento takeuchi`}</small>
  );
};

export default Copyright;
